import { render, staticRenderFns } from "./Ticksvg.vue?vue&type=template&id=49a700fc"
import script from "./Ticksvg.vue?vue&type=script&lang=js"
export * from "./Ticksvg.vue?vue&type=script&lang=js"
import style0 from "./Ticksvg.vue?vue&type=style&index=0&id=49a700fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports